import douyinPng from "../../../assert/images/douyin.png"
import meituanPng from "../../../assert/images/meituan.png"
import {Avatar} from "antd"
import React from "react"
import PlatformCode from "../common/ClubPlatformContanst"

const ClubPlatformAvatar = ({platformId}) => {
    let url = ''
    switch (platformId) {
        case PlatformCode.MeiTuan:
            url = meituanPng
            break
        case PlatformCode.DouYin:
            url = douyinPng
            break
        default:
            url = ''
    }

    return <Avatar src={url}/>
}

export default ClubPlatformAvatar


// WEBPACK FOOTER //
// ./src/containers/ClubPlatform/component/ClubPlatformAvator.js